module.exports = __webpack_public_path__ + "img/HZ-P1291.ff8ea6f3.png";